import { REFRESH_TOKEN_KEY } from '../constants/storage'
import { type ApiEndpoints } from '../services/api'
import { type Tokens } from '../types/UserStateType'

export const setTokens = ({ api, data }: { api: ApiEndpoints; data: Tokens }) => {
  localStorage.setItem(REFRESH_TOKEN_KEY, data.refreshToken)
  api.setHeader('Authorization', `Bearer ${data.accessToken}`)
}
